/**
 * @generated SignedSource<<e8f79310f2b269fd4d8f0d898c75b1f4>>
 * @relayHash 7fd387dd0b179fae2aa596ad482acf65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 708fa0141ed02d1de7eb0e42c1c237c7cdf8bea33cbd405e88e72d1cf8ef3c82

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePagePdfExportVersion = "V1" | "V2" | "V3" | "%future added value";
export type useCreatePagePdfExportTaskMutation$variables = {
  contentId: string;
};
export type useCreatePagePdfExportTaskMutation$data = {
  readonly confluence_createPdfExportTaskForSingleContent: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly exportTaskId: string;
    readonly exportVersion: ConfluencePagePdfExportVersion;
    readonly success: boolean;
  } | null;
};
export type useCreatePagePdfExportTaskMutation = {
  response: useCreatePagePdfExportTaskMutation$data;
  variables: useCreatePagePdfExportTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
    "kind": "LinkedField",
    "name": "confluence_createPdfExportTaskForSingleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "kind": "ScalarField",
        "name": "exportTaskId"
      },
      {
        "kind": "ScalarField",
        "name": "exportVersion"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreatePagePdfExportTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreatePagePdfExportTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7fd387dd0b179fae2aa596ad482acf65",
    "id": "708fa0141ed02d1de7eb0e42c1c237c7cdf8bea33cbd405e88e72d1cf8ef3c82",
    "metadata": {},
    "name": "useCreatePagePdfExportTaskMutation",
    "operationKind": "mutation",
    "text": "mutation useCreatePagePdfExportTaskMutation($contentId:ID!){confluence_createPdfExportTaskForSingleContent(input:{contentId:$contentId}){success,exportTaskId,exportVersion,errors{message}}}"
  }
};
})();

(node as any).hash = "cb49dcedba5e8450ee2fd34511bc8b44";

export default node;
